<script>
export default { inheritAttrs: false }
</script>

<script setup>
import Button from './Button.vue'
</script>

<template>
    <Button variant="primary" size="lg" v-bind="$attrs" v-on="$listeners">
        <template v-for="(_, name) in $scopedSlots" #[name]="slotProps">
            <slot :name="name" v-bind="slotProps || {}" />
        </template>
    </Button>
</template>
